import React from 'react';
import { Spin, Tooltip } from 'antd';
import { CloseOutlined, RobotOutlined, LoadingOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { openAiDrawer, resetAiExtraction } from '../../appRedux/actions/AiExtraction';

/**
 * 右上角浮动按钮：提示文档 AI 抽取的进度。
 * - processing：转圈 + "AI 正在分析…"（始终显示，不阻塞页面其它操作）
 * - done：结果就绪，点击重新打开抽屉（抽屉已开时不再重复显示）
 * - error：红色错误条，可关闭
 * 全局挂在 MainApp，只读 Redux，故关掉抽屉后仍能由它再次打开。
 */
const AIExtractionIndicator = () => {
  const { status, drawerOpen, error } = useSelector(({ aiExtraction }) => aiExtraction);
  const dispatch = useDispatch();

  if (status === 'idle') return null;
  // 处理中始终显示；done 时若抽屉已打开则隐藏浮动条（避免重复）
  if (status === 'done' && drawerOpen) return null;

  if (status === 'processing') {
    return (
      <div className="ai-extraction-indicator ai-extraction-indicator--processing">
        <Spin indicator={<LoadingOutlined spin style={{ fontSize: 16, color: '#fff' }} />} />
        <span className="ai-extraction-indicator__text">AI is analysing document(s)…</span>
      </div>
    );
  }

  if (status === 'done') {
    return (
      <div
        className="ai-extraction-indicator ai-extraction-indicator--done"
        onClick={() => dispatch(openAiDrawer())}
      >
        <RobotOutlined style={{ fontSize: 16 }} />
        <span className="ai-extraction-indicator__text">AI result ready · View</span>
        <Tooltip title="Dismiss">
          <CloseOutlined
            className="ai-extraction-indicator__close"
            onClick={(e) => { e.stopPropagation(); dispatch(resetAiExtraction()); }}
          />
        </Tooltip>
      </div>
    );
  }

  // error
  return (
    <div className="ai-extraction-indicator ai-extraction-indicator--error">
      <ExclamationCircleOutlined style={{ fontSize: 16 }} />
      <span className="ai-extraction-indicator__text" title={error}>AI failed: {error}</span>
      <CloseOutlined
        className="ai-extraction-indicator__close"
        onClick={() => dispatch(resetAiExtraction())}
      />
    </div>
  );
};

export default AIExtractionIndicator;
